<button class="login-link forgot-button" mat-flat-button color="accent" matTooltip="{{ logout ? ('loginForm.exit' | translate) : ('loginForm.return' | translate)}}"
        [routerLink]="routerLink"  type="button">
    <mat-icon class="forgot-icon">reply</mat-icon>
    {{ logout ? ('loginForm.exit' | translate) : ('loginForm.return' | translate)}}
</button>
